/** USD from integer cents, no trailing .00 on whole dollars. Its own module
 *  (re-exported by lib/api) so tests can import it without the API client. */
export function formatUsd(cents: number): string {
  const dollars = cents / 100;
  return dollars.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: Number.isInteger(dollars) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}
